import React from 'react';
import s from './s.modules.less';
import Frame from './frame.png';

const HowItWork = () => {
    return (
        <div className={s.howItWordsWrap}>
            <div className={s.title}>How Klarity Pay Later work</div>
            <div className={s.list}>
                <div className={s.item}>
                    <div className={s.header}>
                        <span className={s.icon}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17" fill="none">
                                <path d="M4.16634 8.33203H9.16634M4.16634 11.6654H9.16634M10.833 15.832H2.49967C1.5792 15.832 0.833008 15.0858 0.833008 14.1654V2.4987C0.833008 1.57822 1.5792 0.832031 2.49967 0.832031H7.1545C7.37551 0.832031 7.58747 0.919829 7.74375 1.07611L12.2556 5.58795C12.4119 5.74423 12.4997 5.9562 12.4997 6.17721V14.1654C12.4997 15.0858 11.7535 15.832 10.833 15.832Z" stroke="#0E62F4" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </span>
                        <span>Step 1</span>
                    </div>
                    <div className={s.content}>
                        Apply online through Klarity provider portal, it only takes a few minutes.
                    </div>
                </div>
                <div className={s.item}>
                    <div className={s.header}>
                        <span className={s.icon}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17" fill="none">
                                <path d="M4.16634 8.33203H9.16634M4.16634 11.6654H9.16634M10.833 15.832H2.49967C1.5792 15.832 0.833008 15.0858 0.833008 14.1654V2.4987C0.833008 1.57822 1.5792 0.832031 2.49967 0.832031H7.1545C7.37551 0.832031 7.58747 0.919829 7.74375 1.07611L12.2556 5.58795C12.4119 5.74423 12.4997 5.9562 12.4997 6.17721V14.1654C12.4997 15.0858 11.7535 15.832 10.833 15.832Z" stroke="#0E62F4" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </span>
                        <span>Step 2</span>
                    </div>
                    <div className={s.content}>
                        Get approved within 1-2 business days.
                    </div>
                </div>
                <div className={s.item}>
                    <div className={s.header}>
                        <span className={s.icon}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17" fill="none">
                                <path d="M4.16634 8.33203H9.16634M4.16634 11.6654H9.16634M10.833 15.832H2.49967C1.5792 15.832 0.833008 15.0858 0.833008 14.1654V2.4987C0.833008 1.57822 1.5792 0.832031 2.49967 0.832031H7.1545C7.37551 0.832031 7.58747 0.919829 7.74375 1.07611L12.2556 5.58795C12.4119 5.74423 12.4997 5.9562 12.4997 6.17721V14.1654C12.4997 15.0858 11.7535 15.832 10.833 15.832Z" stroke="#0E62F4" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </span>
                        <span>Step 3</span>
                    </div>
                    <div className={s.content}>
                        Use Klarity Pay Later to cover marketing services like Pro-Listings or Standard Listings.
                    </div>
                </div>
                <div className={s.item}>
                    <div className={s.header}>
                        <span className={s.icon}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17" fill="none">
                                <path d="M4.16634 8.33203H9.16634M4.16634 11.6654H9.16634M10.833 15.832H2.49967C1.5792 15.832 0.833008 15.0858 0.833008 14.1654V2.4987C0.833008 1.57822 1.5792 0.832031 2.49967 0.832031H7.1545C7.37551 0.832031 7.58747 0.919829 7.74375 1.07611L12.2556 5.58795C12.4119 5.74423 12.4997 5.9562 12.4997 6.17721V14.1654C12.4997 15.0858 11.7535 15.832 10.833 15.832Z" stroke="#0E62F4" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </span>
                        <span>Step 4</span>
                    </div>
                    <div className={s.content}>
                        Delay your payments for up to 90 days after your marketing investments start bringing new patients.
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HowItWork;
